<template>
  <div class="">
      <v-dialog v-model="dialog" :fullscreen="isMobile">
        <v-card>
            <v-toolbar dense color="primary darken-3 white--text">
              <v-toolbar-title>Roles y habilidades</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn icon @click="close()" color="white">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
              <roles-editor>
              </roles-editor>
          </v-card-text>
          <v-divider></v-divider>
          <!-- <v-card-actions>
            <v-btn color="blue darken-1" flat @click="close()">Close</v-btn>
            <v-btn color="blue darken-1" flat @click="save()">Save</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
import rolesEditor from '@/views/rolesEditor'
export default {
  name: "rolesDialog",
  components: {
    rolesEditor
  },
  props: {
    value: {default: false, type:Boolean},
  },
  data: () => ({
    dialog:false,
  }),
  computed:{
    isMobile(){
      return this.$store.getters.isMobile;
    }
  },
  watch:{
    dialog(){
      this.$emit("input", this.dialog);
    },
    value(){
      this.dialog = this.value;
    }
  },
  created(){
    this.dialog = this.value;
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    save() {
      this.close();
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
